import session from '@/services/authentication/session'
import _ from 'lodash'

let bearerInterceptor = {
    type: 'request',

    process (request) {
        let token = ''
        let storedToken = session.getToken()

        if (storedToken != 'undefined' && storedToken != null) {
            token = 'Bearer ' 
                + (_.endsWith(request.url, 'refresh-token') ? 
                session.getRefreshToken() 
                : session.getToken())
        }

        // request interceptor
        request.headers.common['Authorization'] = token

        return request
    },

    exception (error) {
        return Promise.reject(error)
    }
}

export { bearerInterceptor }
